import type { FragmentType } from 'src/gql';
import type { Deprecated_HandleItemUpdate } from 'src/types/account';
import { useState } from 'react';
import { UpdateType } from 'src/constants/portfolio';
import { graphql, unmaskFragment } from 'src/gql';

import { useMutationWithErrorLogging } from '@savvy/graphql-hooks/useMutationWithErrorLogging';

import { NetWorthItemMenu } from './views/net-worth-item-menu';

export const NetWorthAssetMenuFragment = graphql(/* GraphQL */ `
  fragment NetWorthAssetMenu on Asset {
    id
    hiddenFromClient
    hiddenFromNetWorth
  }
`);

const UPDATE_ASSET = graphql(/* GraphQL */ `
  mutation UpdateAssetFromNetWorthAccountItemMenu($input: UpdateAssetInput!) {
    updateAsset(input: $input) {
      asset {
        id
      }
    }
  }
`);

export function NetWorthAssetMenu({
  advisorView,
  assetFrag,
  onEdit,
}: {
  readonly advisorView?: boolean;
  readonly assetFrag: FragmentType<typeof NetWorthAssetMenuFragment>;
  readonly onEdit: Deprecated_HandleItemUpdate;
}) {
  const asset = unmaskFragment(NetWorthAssetMenuFragment, assetFrag);
  const [updateAsset] = useMutationWithErrorLogging(UPDATE_ASSET);
  const [hiddenFromNetWorth, setHiddenFromNetWorth] = useState(!!asset.hiddenFromNetWorth);
  const [hiddenFromClient, setHiddenFromClient] = useState(!!asset.hiddenFromClient);

  async function handleChange(field: 'hiddenFromNetWorth' | 'hiddenFromClient', value: boolean) {
    const updateType = UpdateType.SHOW_HIDE_NET_WORTH;

    await updateAsset({
      variables: {
        input: {
          id: asset.id,
          [field]: !value,
        },
      },
    });

    await onEdit({
      type: updateType,
      id: asset.id,
    });
  }

  return (
    <NetWorthItemMenu
      advisorView={advisorView}
      hiddenFromClient={hiddenFromClient}
      hiddenFromNetWorth={hiddenFromNetWorth}
      isManagedAccount={false}
      handleChange={handleChange}
      setHiddenFromClient={setHiddenFromClient}
      setHiddenFromNetWorth={setHiddenFromNetWorth}
    />
  );
}
